import React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';

const WebshopProgressBar = ({ currentPath }) => {
  const stepOne = currentPath === '/cart';
  const stepTwo = currentPath === ('/cart/checkout/login-or-register' || '/cart/checkout');
  const stepThree = currentPath === '/cart/checkout/confirm';
  const stepLoginOrRegister = currentPath === '/cart/checkout/login-or-register';

  return (
    <>
      <div className="StepsProgressBar__step StepsProgressBar__webShop">
        <CoreLink to="/cart">
          <div className="StepsProgressBar__step__number__done"><span>{stepTwo || stepThree ? <div className="icon icon-check icon-variant-2" /> : 1}</span></div>
        </CoreLink>
        <div className="StepsProgressBar__step__name">Winkelwagen</div>
      </div>

      <div className="StepsProgressBar__line" />

      <div className="StepsProgressBar__step StepsProgressBar__webShop">
        <CoreLink to={stepLoginOrRegister ? '/cart/checkout/login-or-register' : '/cart/checkout'}>
          <div className={!stepOne ? 'StepsProgressBar__step__number__done' : 'StepsProgressBar__step__number'}><span>{stepThree ? <div className="icon icon-check icon-variant-2" /> : 2}</span></div>
        </CoreLink>
        <div className="StepsProgressBar__step__name">Gegevens</div>
      </div>

      <div className="StepsProgressBar__line" />

      <div className="StepsProgressBar__step StepsProgressBar__webShop">
        <div className={stepThree ? 'StepsProgressBar__step__number__done' : 'StepsProgressBar__step__number'}><span>3</span></div>
        <div className="StepsProgressBar__step__name">Afrekenen</div>
      </div>
    </>
  );
};

export default WebshopProgressBar;
